export default "__VITE_ASSET__PKuJJFrg__"